import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { insuranceResource } from './../../insuranceManage/request';
import { customerResource } from './../../../system/customerManage/request';
import { getTemplateList, getTemplateResource, customerInsuranceDetail, addConfigurationTemplate, editConfigurationTemplate, getConfigurationTemplateDetail, getFieldMaintenance } from '../request';
const sortMap = {
  1: 'app',
  2: 'h5',
  3: 'pc',
  4: '小程序'
};
import { applicationResource2 } from './../../../customer/applicationManage/request';
export default {
  props: {
    insuranceId: {
      type: Number,
      default: 0
    },
    customerInsuranceId: {
      type: Number,
      default: 0
    },
    customerId: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      columns: [{
        slots: {
          title: '模板id'
        },
        dataIndex: 'id',
        key: '1',
        align: 'center',
        width: 80
      }, {
        slots: {
          title: '模板名称'
        },
        dataIndex: 'fileTemplateName',
        key: '2',
        align: 'center',
        ellipsis: true
      }, {
        slots: {
          title: '应用名称'
        },
        dataIndex: 'applicationName',
        key: '3',
        align: 'center',
        ellipsis: true
      }, {
        slots: {
          title: '应用类型'
        },
        dataIndex: 'applicationType',
        key: '4',
        align: 'center',
        ellipsis: true
      }, {
        slots: {
          title: '触发锚点'
        },
        dataIndex: 'anchorPoint',
        key: '5',
        align: 'center',
        ellipsis: true,
        scopedSlots: {
          customRender: 'anchorPointRender'
        }
      }, {
        slots: {
          title: '状态'
        },
        dataIndex: 'status',
        key: '6',
        align: 'center',
        ellipsis: true,
        scopedSlots: {
          customRender: 'status'
        }
      }, {
        slots: {
          title: '操作'
        },
        key: '7',
        align: 'center',
        width: 230,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      data: [],
      visible: false,
      form: {},
      mainList: [],
      customerList: [],
      fileList: [],
      applicationList: [],
      productName: '',
      applicationId: '',
      applicationType: '',
      isEdit: false,
      fieldMaintenanceData: [],
      fieldVisible: false
    };
  },
  computed: {
    ruleData() {
      return {
        fileTemplateId: [{
          required: true,
          message: this.$t('请选择') + this.$t('文件模板'),
          trigger: 'change'
        }]
      };
    }
  },
  created() {
    this.getTemplateListData();
    this.getInfo();
  },
  methods: {
    async getInfo() {
      const res = await customerInsuranceDetail({
        customerInsuranceId: this.customerInsuranceId
      });
      this.productName = res.name.name;
      this.applicationId = res.applicationId;
      this.applicationType = res.applicationType;
      this.applicationList = await applicationResource2({
        customerId: res.customerId
      });
      insuranceResource({}).then(res => {
        this.mainList = res;
      });
      customerResource().then(res => {
        this.customerList = res;
      });
      getTemplateResource({}).then(res => {
        this.fileList = res;
      });
    },
    getTemplateListData() {
      let params = {
        customerInsuranceId: this.customerInsuranceId,
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      };
      getTemplateList(params).then(res => {
        this.data = res.items.map(item => {
          item.applicationType = sortMap[item.applicationType];
          return item;
        });
        this.pagination.total = res.totalNum;
      });
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getTemplateListData();
    },
    changeStatus(record) {
      let params = {
        type: 'STATUS',
        id: record.id,
        status: record.status == 1 ? 0 : 1
      };
      editConfigurationTemplate(params).then(res => {
        if (res) {
          this.$set(record, 'status', params.status);
        }
      });
    },
    toConfigurationTemplate() {
      var _this$customerList$fi, _this$applicationList;
      let customerName = ((_this$customerList$fi = this.customerList.find(item => item.id == this.customerId)) === null || _this$customerList$fi === void 0 ? void 0 : _this$customerList$fi.name) || '';
      let applicationName = ((_this$applicationList = this.applicationList.find(item => item.id == this.applicationId)) === null || _this$applicationList === void 0 ? void 0 : _this$applicationList.name) || '';
      let applicationType = sortMap[this.applicationType] || '';
      this.visible = true;
      this.$refs.form && this.$refs.form.resetFields();
      this.$set(this.form, 'customerName', customerName);
      this.$set(this.form, 'applicationName', applicationName + '(' + applicationType + ')');
      this.$set(this.form, 'productName', this.productName);
      this.$set(this.form, 'fileTemplateId', []);
      this.isEdit = false;
    },
    newConfigurationTemplate() {
      this.$refs.form.validate(valid => {
        if (valid) {
          let params = {
            customerInsuranceId: this.customerInsuranceId,
            fileTemplateId: this.form.fileTemplateId.join()
          };
          addConfigurationTemplate(params).then(res => {
            if (res) {
              this.visible = false;
              this.getTemplateListData();
            }
          });
        }
      });
    },
    handleChange(record) {
      let params = {
        type: 'ANCHOR_POINT',
        id: record.id,
        anchorPoint: record['anchorPoint']
      };
      editConfigurationTemplate(params).then(res => {});
    },
    editFileTemplate(record) {
      this.visible = true;
      this.isEdit = true;
      let params = {
        id: record.id
      };
      getConfigurationTemplateDetail(params).then(res => {
        if (res && res.id) {
          let applicationType = sortMap[res.applicationType] || '';
          this.$set(this.form, 'customerName', res.customerName);
          this.$set(this.form, 'productName', res.insuranceName);
          this.$set(this.form, 'applicationName', res.applicationName + '(' + applicationType + ')');
          this.$set(this.form, 'fileTemplateId', res.fileTemplateId);
        }
      });
    },
    fieldMaintenance(record) {
      let params = {
        fileTemplateId: record.fileTemplateId
      };
      this.fieldVisible = true;
      getFieldMaintenance(params).then(res => {
        if (res) {
          this.fieldMaintenanceData = res;
        }
      });
    }
  }
};